import { Location, matchPath } from 'react-router';
import { ProtectedPage } from 'components';
import { BreadcrumbRouteObject } from 'types';
import { ROUTING_PATHS } from 'const';
import {
  GeneralList,
  CertificationExpiredList,
  CertificationExpireSoonList,
  MonitoringExpiredList,
  MonitoringExpireSoonList,
  TrainingNotCompletedList,
  TrainingUpcomingList,
} from './examiner-list';
import { ExaminerListType } from 'api';

const { examiners } = ROUTING_PATHS;

const LIST_TYPE_TITLES: Record<ExaminerListType, string> = {
  [ExaminerListType.General]: 'search',
  [ExaminerListType.CertificationExpired]: 'certification expired',
  [ExaminerListType.CertificationExpireSoon]: 'certification will expire soon',
  [ExaminerListType.MonitoringExpired]: 'monitoring expired',
  [ExaminerListType.MonitoringExpireSoon]: 'monitoring will expire soon',
  [ExaminerListType.TrainingUpcoming]: 'training upcoming',
  [ExaminerListType.TrainingNotCompleted]: 'training not completed',
};

const CERTIFICATION_TYPE_LABELS: Record<string, string> = {
  speaking: 'Speaking',
  writing: 'Writing',
  speakingonline: 'Online Speaking',
  lifeskills: 'Life Skills',
};

const getHeader = (location: Location, subtitle?: string) => {
  const match = matchPath(examiners.list.path + '/:certificationType/*', location.pathname);
  let certificationTypeName = LIST_TYPE_TITLES[ExaminerListType.General];

  if (match?.params.certificationType) {
    certificationTypeName =
      CERTIFICATION_TYPE_LABELS[match.params.certificationType] || match.params.certificationType;
  }
  return `Examiners - ${certificationTypeName} ${subtitle || ''}`;
};

export const EXAMINERS_ROUTES: BreadcrumbRouteObject[] = [
  {
    path: examiners.list.path,
    breadcrumb: { text: (location) => getHeader(location), icon: 'users' },
    element: (
      <ProtectedPage {...examiners.list}>
        <GeneralList />
      </ProtectedPage>
    ),
  },
  {
    path: examiners.certificationExpiredList.path,
    breadcrumb: {
      text: (location) =>
        getHeader(location, LIST_TYPE_TITLES[ExaminerListType.CertificationExpired]),
      icon: 'users',
    },
    element: (
      <ProtectedPage {...examiners.certificationExpiredList}>
        <CertificationExpiredList />
      </ProtectedPage>
    ),
  },
  {
    path: examiners.certificationExpireSoonList.path,
    breadcrumb: {
      text: (location) =>
        getHeader(location, LIST_TYPE_TITLES[ExaminerListType.CertificationExpireSoon]),
      icon: 'users',
    },
    element: (
      <ProtectedPage {...examiners.certificationExpireSoonList}>
        <CertificationExpireSoonList />
      </ProtectedPage>
    ),
  },
  {
    path: examiners.monitoringExpiredList.path,
    breadcrumb: {
      text: (location) => getHeader(location, LIST_TYPE_TITLES[ExaminerListType.MonitoringExpired]),
      icon: 'users',
    },
    element: (
      <ProtectedPage {...examiners.monitoringExpiredList}>
        <MonitoringExpiredList />
      </ProtectedPage>
    ),
  },
  {
    path: examiners.monitoringExpireSoonList.path,
    breadcrumb: {
      text: (location) =>
        getHeader(location, LIST_TYPE_TITLES[ExaminerListType.MonitoringExpireSoon]),
      icon: 'users',
    },
    element: (
      <ProtectedPage {...examiners.monitoringExpireSoonList}>
        <MonitoringExpireSoonList />
      </ProtectedPage>
    ),
  },
  {
    path: examiners.trainingNotCompletedList.path,
    breadcrumb: {
      text: (location) =>
        getHeader(location, LIST_TYPE_TITLES[ExaminerListType.TrainingNotCompleted]),
      icon: 'users',
    },
    element: (
      <ProtectedPage {...examiners.trainingNotCompletedList}>
        <TrainingNotCompletedList />
      </ProtectedPage>
    ),
  },
  {
    path: examiners.trainingUpcomingList.path,
    breadcrumb: {
      text: (location) => getHeader(location, LIST_TYPE_TITLES[ExaminerListType.TrainingUpcoming]),
      icon: 'users',
    },
    element: (
      <ProtectedPage {...examiners.trainingUpcomingList}>
        <TrainingUpcomingList />
      </ProtectedPage>
    ),
  },
];
